import styled from 'styled-components';
// import theme from '../theme';

const FinishSignInStyles = styled.div``;

export default FinishSignInStyles;
